import { createSelector } from '@reduxjs/toolkit';

import { pickBy } from 'lodash';

import { getFlexDates, getNightsRange } from './utils';
import { name } from './slice';
import type { PriceSubscriptionState } from './types';

import {
  getDeparture,
  getDestination,
  getNights,
  getIsFlexNights,
  getIsFlexDate,
  getStartDate,
  getAdults,
  getKids,
} from '../searcher/selectors';

/**
 * Параметры для pricewatch подписки
 */
export const paramsForSubscribtionSelector = createSelector(
  [
    getDestination,
    getDeparture,
    getIsFlexNights,
    getIsFlexDate,
    getStartDate,
    getNights,
    getAdults,
    getKids,
  ],
  (
    destination,
    departure,
    hasFlexNights,
    hasFlexDates,
    startDate,
    nights,
    adults,
    kidsAges,
  ) => {
    const flexDates = getFlexDates(startDate, hasFlexDates);

    // убираем пустые параметры
    return pickBy({
      adults,
      nights: getNightsRange(nights, hasFlexNights),
      kids: kidsAges,
      place_ids: [destination.id],
      departure_ids: [departure.id],
      start_date_from: flexDates.from,
      start_date_to: flexDates.to,
    });
  },
);

/**
 * Параметры для отображения pricewatch подписки
 */
export const viewParamsForSubscribtionSelector = createSelector(
  [getDestination, getIsFlexNights, getIsFlexDate, getStartDate, getNights],
  (destination, hasFlexNights, hasFlexDates, startDate, nightCount) => ({
    startDate,
    hasFlexDates,
    hasFlexNights,
    nightCount,
    countryRu: destination.name_ru_form3,
  }),
);

export const priceSubscriptionSelector = (state): PriceSubscriptionState =>
  state.get(name);

export const isSubscribedOnPriceSelector = createSelector(
  priceSubscriptionSelector,
  (state) => state.isSubscribed,
);
